import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {
  selectBuildingsDamage,
  selectCitiesCache,
  selectCurrentPlayer,
  selectCurrentPlayerCities,
  selectGameResults,
  selectGameType,
  selectHexes,
  selectIsGameStarted,
  selectPendingRecruitmentActions,
  selectPendingSupply,
  selectPhase,
  selectPlayers,
  selectSelectedFarmsForConversion,
  selectSpecialBuildings,
  selectUnits,
  selectWarPhaseStage
} from "../../../redux/reducers/sharedStateReducer/selectors";
import {GAME_TYPES} from "../../../constants/game";
import {REGISTRY_SINGLETON} from "../../../scenes/Registry";
import {useIsCurrentUserTurn} from "../../../utils/gameState/user/useIsCurrentUserCurrentPlayer";
import {executePhaseAutoActions} from "../../../utils/gameState/turn/executePhaseAutoActions";
import store from "../../../redux/store";
import {selectIsTutorialActive} from "../../../redux/reducers/privateStateReducer/selectors";

const PhaseAutoComplitioner = () => {
  const isCurrentUserTurn = useIsCurrentUserTurn();
  // Обучение: авто-раздача и авто-завершения выключены — снабжение и
  // завершение фаз игрок прожимает руками по шагам сценария
  const isTutorialActive = useSelector(selectIsTutorialActive);
  const gameType = useSelector(selectGameType);
  const phase = useSelector(selectPhase);
  const warPhaseStage = useSelector(selectWarPhaseStage);
  const isGameStarted = useSelector(selectIsGameStarted);
  const currentPlayer = useSelector(selectCurrentPlayer);
  const units = useSelector(selectUnits);
  const citiesCache = useSelector(selectCitiesCache);
  const hexes = useSelector(selectHexes);
  const gameResults = useSelector(selectGameResults);
  const currentPlayerCities = useSelector(selectCurrentPlayerCities);
  const pendingSupply = useSelector(selectPendingSupply);
  const specialBuildings = useSelector(selectSpecialBuildings);
  const players = useSelector(selectPlayers);
  const pendingRecruitmentActions = useSelector(selectPendingRecruitmentActions);
  const buildingsDamage = useSelector(selectBuildingsDamage);
  const selectedFarmsForConversion = useSelector(selectSelectedFarmsForConversion);

  useEffect(() => {
    if (isTutorialActive) {
      return;
    }
    if (gameType !== GAME_TYPES.LOCAL) {
      return;
    }

    if (!isGameStarted || !currentPlayer || gameResults || !isCurrentUserTurn) {
      return;
    }

    // Ходы ботов авто-действиями ведет сам движок ботов (executeBotStep):
    // он вызывает тот же алгоритм в нужном порядке (например, крысолюды сначала
    // нанимают d6 за снабжение на пустых фермах, и только потом идет авто-раздача)
    if (currentPlayer.isBot) {
      return;
    }

    executePhaseAutoActions(store, true, REGISTRY_SINGLETON.getHexGridRenderer());
  }, [
    gameType,
    phase,
    warPhaseStage,
    isGameStarted,
    currentPlayer,
    units,
    citiesCache,
    hexes,
    gameResults,
    currentPlayerCities,
    pendingSupply,
    specialBuildings,
    players,
    pendingRecruitmentActions,
    buildingsDamage,
    isCurrentUserTurn,
    selectedFarmsForConversion
    , isTutorialActive]);

  return null;
};

export default PhaseAutoComplitioner;
